import { useEffect, useState, useRef, useMemo } from "react";
import axios from "../../../../axios";
import {
  errorToast,
  successToast,
  warningToast,
} from "../../../../utils/toast";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { useTranslation } from "react-i18next";
import TimerImage from "../../../../Images/timeupimage.png";
import Loding from "../../../../componant/Loader/Loding";
import { useToast } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import {
  CheckCircle,
  XCircle,
  AlertCircle,
  Clock,
  SkipForward,
  ArrowRight,
  Info,
} from "lucide-react";
import { useUser } from "../../../../hooks/use-user";
import { useNavigate } from "react-router-dom";

const ContestQuestion = (props) => {
  const toast = useToast({ position: "top" });
  const location = useLocation();
  const contestIdFromState = location.state?.contestId;
  const [t, i18n] = useTranslation();
  const [loading, setLoading] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [data, setData] = useState({});
  const [nextdata, setNextdata] = useState({});
  const [userdata, setUserdata] = useState({});
  const [selectedOption, setSelectedOption] = useState(null);
  const [correctAnswers, setCorrectAnswers] = useState(0);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);
  const [timeLeft, setTimeLeft] = useState(30);
  const [showButton, setShowButton] = useState(false);
  const [showTimerButton, setShowTimerButton] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [TimeOut, setIsTimeout] = useState(false);
  const timerRef = useRef(null);
  const { data: user } = useUser();
  const [Contestdata, setContestData] = useState([]);
  const [userContestdata, setUserContestData] = useState([]);
  const [totalQuestions, setTotalQuestions] = useState(0);
  const [contestCompleted, setContestCompleted] = useState(false);
  const [completeData, setCompleteData] = useState({
    rightCount: 0,
    wrongCount: 0,
    skipCount: 0,
  });
  const [showSubmitModal, setShowSubmitModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchData() {
      axios.get("getAllContestForUser").then((response) => {
        if (response?.data) {
          setContestData(response?.data?.result);
        }
      });
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (Contestdata && Contestdata.length > 0) {
      const activeContestId = contestIdFromState;
      const result = Contestdata.find((el) => el._id == activeContestId);
      setUserContestData(result);
    }
  }, [Contestdata, contestIdFromState]);

  const fetchData = async () => {
    setLoading(true);
    setShowTimerButton(false);

    try {
      const activeContestId = contestIdFromState;
      const response = await axios.get(`getUserContestQuestion`, {
        params: { contestId: activeContestId },
      });
      if (response?.data) {
        if (!response.data.result) {
          clearInterval(timerRef.current);
          setContestCompleted(true);
          return;
        }
        setShowTimerButton(true);
        setData(response.data.result);
      }
    } catch (error) {
      if (error?.response?.data?.message === "No questions available") {
        clearInterval(timerRef.current);
        setContestCompleted(true);
      } else if (error?.response?.data?.message?.includes("time has ended") ||
                 error?.response?.data?.message?.includes("Contest has ended")) {
        // Contest time has ended, force submit
        clearInterval(timerRef.current);
        setTimeUp(true);
        errorToast("Contest time has ended");
        confirmSubmitContest();
      }
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      fetchData();
    }
  }, [user, contestIdFromState]);
  const quetionsLength = async () => {
    axios
      .get(`getContestQuestionsByContestId/${userContestdata._id}`)
      .then((res) => {
        const questions = res?.data?.result?.questions;
        console.log(questions.length, "quetions length");

        if (Array.isArray(questions)) {
          setTotalQuestions(questions.length);
        }
      })
      .catch((err) => {
        setTotalQuestions(0);
        // toast.error("Something went wrong. Please try again.");
      });
  };

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      fetchQuestions(i18n.language);
    }
  }, [data, i18n.language]);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      setTimerBasedOnQuesType(data.quesType);
      setIsDisabled(false);
      setIsSubmitted(false); // Ensure state reset when new data loads
      setIsCorrect(false);
      setSelectedOption(null);
    }
  }, [data]);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      setShowButton(false);
      setIsTimeout(false);
      startTimer();
    }
  }, [questions]);

  const setTimerBasedOnQuesType = (quesType) => {
    if (quesType === "reasoning") {
      setTimeLeft(50);
    } else if (quesType === "maths") {
      setTimeLeft(60);
    } else {
      setTimeLeft(40);
    }
  };

  const fetchQuestions = async (language) => {
    setLoading(true);
    try {
      quetionsLength();
      const fetchedQuestions = {
        question: language !== "hi" ? data.question : data.questionHin,
        options: language !== "hi" ? data.options : data.optionsHin,
        answer: language !== "hi" ? data.answer : data.answerHin,
      };
      setQuestions([fetchedQuestions]);
    } catch (error) {
      console.error("Error fetching questions:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    setIsSubmitted(false);
  };

  const handleSubmit = async () => {
    if (selectedOption === null) {
      toast({
        title: "Please select an option.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    setShowTimerButton(false);
    // Calculate time taken: max time for question type minus remaining time
    const maxTime =
      data?.quesType === "maths"
        ? 60
        : data?.quesType === "reasoning"
          ? 50
          : 40;
    const timeTakenSeconds = maxTime - timeLeft;
    const activeContestId = contestIdFromState;
    const obj = {
      questionId: data?._id,
      answer: selectedOption,
      timeTaken: timeTakenSeconds,
      contestId: activeContestId,
    };

    try {
      const res = await axios.post(`submitContestAnswer`, obj);

      if (res) {
        setLoading(true);
        const isAnswerCorrect = res?.data?.ansRight ?? false;
        setIsCorrect(isAnswerCorrect);
        setIsSubmitted(true);

        if (isAnswerCorrect) {
          setCorrectAnswers((prev) => prev + 1);
          toast({
            title: "Correct Answer!",
            status: "success",
            duration: 2000,
            isClosable: true,
          });
        } else {
          toast({
            title: "Incorrect Answer!",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        }

        setTimeout(() => {
          setSelectedOption(null);
          setLoading(false);

          if (
            !res?.data?.nextQestion ||
            res?.data?.message === "No questions available"
          ) {
            clearInterval(timerRef.current);
            setContestCompleted(true);
          } else {
            setData(res?.data.nextQestion);
            setTimerBasedOnQuesType(res?.data?.nextQestion?.quesType);
            setShowTimerButton(true);
          }
        }, 3000);
    } 
  }
  catch (error) {
      console.error("Error submitting answer:", error);
      errorToast(error?.response?.data?.message || "Failed to submit answer");
      // If contest time has ended, auto-submit
      if (error?.response?.data?.message?.includes("time has ended")) {
        setTimeUp(true);
        confirmSubmitContest();
      }
    }
  }

  const handleSkip = async () => {
    setShowTimerButton(false);
    clearInterval(timerRef.current);

    const maxTime =
      data?.quesType === "maths"
        ? 60
        : data?.quesType === "reasoning"
          ? 50
          : 40;
    const timeTakenSeconds = maxTime - timeLeft;
    const activeContestId = contestIdFromState;
    const obj = {
      questionId: data?._id,
      type: "skip",
      timeTaken: timeTakenSeconds,
      contestId: activeContestId,
    };

    try {
      const res = await axios.post(`submitContestAnswer`, obj);

      if (res) {
        setCompleteData((prev) => ({
          ...prev,
          skipCount: (prev.skipCount || 0) + 1,
        }));
        toast({
          title: "Question Skipped!",
          status: "info",
          duration: 2000,
          isClosable: true,
        });

        setSelectedOption(null);
        setIsSubmitted(false);
        setIsCorrect(false);

        if (
          !res?.data?.nextQestion ||
          res?.data?.message === "No questions available"
        ) {
          setContestCompleted(true);
        } else {
          setData(res?.data.nextQestion);
          setTimerBasedOnQuesType(res?.data?.nextQestion?.quesType);
          setShowTimerButton(true);
          startTimer();
        }
      }
    } catch (error) {
      console.error("Error skipping question:", error);
      errorToast(error?.response?.data?.message || "Failed to skip question");
      // If contest time has ended, auto-submit
      if (error?.response?.data?.message?.includes("time has ended")) {
        setTimeUp(true);
        confirmSubmitContest();
      } else {
        startTimer();
      }
    }
  };

  const confirmSubmitContest = async () => {
    // Prevent double submission
    if (loading || contestCompleted) return;

    try {
      setLoading(true);
      const activeContestId = contestIdFromState;
      const res = await axios.post("submitContest", { contestId: activeContestId });

      if (res?.data?.success) {
        successToast("Contest submitted successfully");
        navigate("/dash/contest-result", {
          state: { contestId: activeContestId },
        });
      }
    } catch (error) {
      errorToast(error?.response?.data?.message || "Failed to submit contest");
    } finally {
      setLoading(false);
      setShowSubmitModal(false);
    }
  };
  const handleSubmitContest = () => {
    const totalAnswered = completeData?.rightCount + completeData?.wrongCount;
    console.log(totalQuestions, "total questions");

    // Agar questions baki hain ya time chal raha hai
    if (!TimeUp && totalAnswered < totalQuestions) {
      setShowSubmitModal(true);
    } else {
      confirmSubmitContest();
    }
  };

  const handleNextQuestion = () => {
    setShowButton(false);
    setSelectedOption(null);
    setIsTimeout(false);
    setIsSubmitted(false); // Reset submitted state
    setIsCorrect(false); // Reset correct state
    fetchData();
    clearInterval(timerRef.current);
    startTimer();
  };

  const startTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }

    timerRef.current = setInterval(() => {
      setTimeLeft((prevTimeLeft) => {
        if (prevTimeLeft <= 1) {
          clearInterval(timerRef.current);
          setShowButton(true);
          setIsDisabled(true);
          setIsTimeout(true);
          return 0;
        }
        return prevTimeLeft - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    if (Object.keys(userdata).length == 0) {
      axios
        .get("me")
        .then((response) => {
          setUserdata(response?.data?.result);
        })
        .catch((err) => {
          errorToast(err?.response?.data?.message || "Failed to load user data");
        });
    }
  }, [userdata]);

  useEffect(() => {
    const activeContestId = contestIdFromState;
    if (!activeContestId) return;

    axios
      .get("getSubmittedContestAnswerRightCount", {
        params: { contestId: activeContestId },
      })
      .then((response) => {
        const userdata = response?.data?.result;
        setCompleteData({
          rightCount: userdata?.totalRightAnswerCount,
          wrongCount: userdata?.totalWrongAnswerCount,
          skipCount: userdata?.totalSkipCount || 0,
        });
      })
      .catch((err) => {
        errorToast(err?.response?.data?.message || "Failed to load contest data");
      });
  }, [data, user, contestIdFromState]);

  const generateOptionLabel = (index) => {
    return String.fromCharCode(65 + index);
  };

  const renderQuestion = () => {
    return (
      <>
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <Loding />
          </div>
        ) : (
          <div className="animate-fade-in-up relative">
            {/* Watermark Overlay */}
            <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden flex items-center justify-center opacity-[0.03]">
              <div className="transform -rotate-45 text-5xl md:text-7xl font-black text-white whitespace-nowrap select-none">
                Learn2Earn 24x7 Learn2Earn 24x7
                <br />
                Learn2Earn 24x7 Learn2Earn 24x7
                <br />
                Learn2Earn 24x7 Learn2Earn 24x7
                <br />
                Learn2Earn 24x7 Learn2Earn 24x7
              </div>
            </div>

            <div className="bg-white/5 rounded-2xl p-6 mb-6 border border-white/10 relative z-10">
              <span className="text-gray-400 text-sm font-semibold uppercase tracking-wider mb-2 block">
                Question
              </span>
              {questions[0] && (
                <h2 className="text-xl md:text-2xl text-white font-bold leading-relaxed relative z-10">
                  {questions[0]?.question}
                </h2>
              )}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 relative z-10">
              {questions[0]?.options?.map((option, index) => (
                <div
                  key={index}
                  className={`relative group cursor-pointer rounded-xl p-4 transition-all duration-300 border-2 transform hover:scale-[1.02] overflow-hidden
                    ${
                      selectedOption === option && isSubmitted
                        ? isCorrect
                          ? "bg-green-500/20 border-green-500"
                          : "bg-red-500/20 border-red-500"
                        : selectedOption === option
                          ? "bg-purple-600/20 border-purple-500"
                          : "bg-white/5 border-white/10 hover:bg-white/10 hover:border-purple-500/50"
                    }`}
                  onClick={() =>
                    !isSubmitted &&
                    handleOptionChange({ target: { value: option } })
                  }
                >
                  {/* Small Watermark in options */}
                  <div className="absolute inset-0 flex items-center justify-center opacity-[0.02] pointer-events-none">
                    <span className="transform -rotate-12 text-2xl font-black text-white">
                      L2E 24x7
                    </span>
                  </div>

                  <div className="flex items-center gap-4 relative z-10">
                    <div
                      className={`w-10 h-10 flex items-center justify-center rounded-lg font-bold text-lg transition-colors ${
                        selectedOption === option
                          ? "bg-purple-500 text-white"
                          : "bg-white/10 text-gray-400 group-hover:bg-white/20 group-hover:text-white"
                      }`}
                    >
                      {generateOptionLabel(index)}
                    </div>
                    <span className="text-base md:text-lg text-white font-medium flex-1">
                      {option}
                    </span>
                    {selectedOption === option && isSubmitted && (
                      <div className="animate-scale-in">
                        {isCorrect ? (
                          <CheckCircle className="text-green-500" size={24} />
                        ) : (
                          <XCircle className="text-red-500" size={24} />
                        )}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </>
    );
  };

  const [TimeUp, setTimeUp] = useState(false);
  useEffect(() => {
    if (!userContestdata?.endTime) return;
    const EndTime = new Date(userContestdata?.endTime);
    const interval = setInterval(() => {
      const now = new Date();
      if (now >= EndTime) {
        setTimeUp(true);
        clearInterval(interval);
        // Stop the per-question timer when contest time ends
        if (timerRef.current) {
          clearInterval(timerRef.current);
        }
        // Auto-submit the contest when time ends
        confirmSubmitContest();
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [userContestdata?.endTime]);

 if (contestCompleted) {
    return (
      <div className="min-h-screen bg-[#2A1B3D] pt-16 pb-20 px-4 flex flex-col items-center justify-center">
        <div className="bg-[#3F234E] rounded-3xl p-10 border border-white/5 shadow-xl max-w-md w-full text-center">
          <CheckCircle className="text-green-500 mx-auto mb-4" size={64} />

          <h2 className="text-2xl font-bold text-white mb-2">
            Contest Completed!
          </h2>

          <p className="text-gray-400 mb-6">
            You have answered all the questions in this contest.
          </p>

          <div className="flex justify-center gap-6 mb-6">
            <div className="text-center">
              <span className="text-green-500 text-3xl font-bold block">
                {completeData?.rightCount}
              </span>
              <span className="text-gray-400 text-sm">Correct</span>
            </div>

            <div className="text-center">
              <span className="text-red-500 text-3xl font-bold block">
                {completeData?.wrongCount}
              </span>
              <span className="text-gray-400 text-sm">Wrong</span>
            </div>

            <div className="text-center">
              <span className="text-yellow-500 text-3xl font-bold block">
                {completeData?.skipCount}
              </span>
              <span className="text-gray-400 text-sm">Skipped</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#2A1B3D] pt-16 pb-20 px-4 flex flex-col items-center">

      <button
        onClick={handleSubmitContest}
        className="items-center text-white font-bold mb-8 bg-[#3F234E] p-4 rounded-2xl border border-white/5 shadow-lg hover:bg-purple-600 transition"
      >
        Submit Contest
      </button>

      <div className="w-full max-w-5xl flex flex-col lg:flex-row gap-8">

        {/* Question Section */}
        <div className="flex-1 order-2 lg:order-1">
          {data ? (
            renderQuestion()
          ) : (
            <div className="text-white text-center">Loading Question...</div>
          )}
        </div>

        {/* Sidebar */}
        <div className="lg:w-80 order-1 lg:order-2 flex flex-col gap-6">

          {/* Timer */}
          <div className="bg-[#3F234E] rounded-3xl p-6 border border-white/5 flex flex-col items-center justify-center shadow-xl relative overflow-hidden">

            {TimeOut ? (
              <div className="flex flex-col items-center text-center animate-pulse">
                <Clock size={48} className="text-red-500 mb-2" />
                <h3 className="text-xl font-bold text-white">Time's Up!</h3>
                <p className="text-gray-400 text-sm">Move to next question</p>
              </div>
            ) : (
              <div className="relative w-40 h-40">
                <CircularProgressbar
                  value={
                    (timeLeft /
                      (data?.quesType === "maths"
                        ? 60
                        : data?.quesType === "reasoning"
                        ? 50
                        : 40)) *
                    100
                  }
                  text={`${timeLeft}`}
                  styles={buildStyles({
                    rotation: 0.25,
                    strokeLinecap: "round",
                    textSize: "24px",
                    pathTransitionDuration: 0.5,
                    pathColor: timeLeft <= 10 ? "#ef4444" : "#a855f7",
                    textColor: "#fff",
                    trailColor: "rgba(255,255,255,0.1)",
                  })}
                />

                <div className="absolute top-full left-0 w-full text-center -mt-8">
                  <span className="text-gray-400 text-sm">Seconds Left</span>
                </div>
              </div>
            )}

          </div>

          {/* Buttons */}
          <div className="flex flex-col gap-3">

            {showButton ? (
              <button
                onClick={handleNextQuestion}
                className="w-full py-4 rounded-xl bg-gradient-to-r from-purple-600 to-indigo-600 text-white font-bold shadow-lg shadow-purple-500/30 hover:scale-[1.02] active:scale-95 transition-all flex items-center justify-center gap-2"
              >
                Next Question <ArrowRight size={20} />
              </button>
            ) : (
              <button
                onClick={handleSubmit}
                disabled={TimeUp || isDisabled}
                className={`w-full py-4 rounded-xl font-bold shadow-lg flex items-center justify-center gap-2 transition-all hover:scale-[1.02] active:scale-95 ${
                  TimeUp || isDisabled
                    ? "bg-gray-700 text-gray-400 cursor-not-allowed"
                    : "bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-green-500/30"
                }`}
              >
                {TimeUp ? "Contest Ended" : "Save & Next"}
              </button>
            )}

            <button
              onClick={handleSkip}
              disabled={TimeUp || isDisabled || isSubmitted}
              className={`w-full py-4 rounded-xl font-bold shadow-lg flex items-center justify-center gap-2 transition-all hover:scale-[1.02] active:scale-95 ${
                TimeUp || isDisabled || isSubmitted
                  ? "bg-gray-700 text-gray-400 cursor-not-allowed"
                  : "bg-gradient-to-r from-gray-600 to-gray-700 text-white shadow-gray-500/30"
              }`}
            >
              Skip Question
            </button>

          </div>
        </div>
      </div>

      {/* Submit Modal */}
      {showSubmitModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-md">
          <div className="relative bg-[#2A1B3D] border border-white/10 rounded-3xl p-8 text-center shadow-2xl">

            <div className="flex justify-center mb-4">
              <AlertCircle size={32} className="text-red-400" />
            </div>

            <h2 className="text-2xl font-bold text-white mb-3">
              Submit Contest Early?
            </h2>

            <p className="text-gray-300 mb-6">
              You still have unanswered questions and remaining time.
            </p>

            <div className="flex justify-center gap-4">

              <button
                onClick={() => setShowSubmitModal(false)}
                className="px-6 py-3 rounded-xl bg-white/10 text-white"
              >
                Cancel
              </button>

              <button
                onClick={confirmSubmitContest}
                className="px-6 py-3 rounded-xl bg-gradient-to-r from-red-500 to-pink-600 text-white"
              >
                Yes, Submit
              </button>

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContestQuestion;